/**
 * Query scope for the To schedule tab (BAR-3096): Ready to schedule patients, in Financing &
 * approval or Pre-procedure (BAR-3107), narrowed by the hub's filters on their tags.
 */

import { Meta } from '@medplum/fhirtypes';
import { patientFilterClauses, QueueFilterValues } from './queueFilters';
import { isReadyToSchedule, READY_TO_SCHEDULE_CLAUSE } from './readyToScheduleScope';

export function buildToScheduleFilter(values: QueueFilterValues): string {
  return `(${[READY_TO_SCHEDULE_CLAUSE, ...patientFilterClauses(values, '')].join(' and ')})`;
}

/** For rows that arrive by subscription: one no longer Ready to schedule, or now Won, leaves the tab. */
export function matchesToSchedule(patient: { meta?: Meta } | undefined): boolean {
  return isReadyToSchedule(patient);
}
